import { DatePicker, DatePickerProps, DialogContent, DialogContentProps } from 'omakase';
import React from 'react';
import _ from 'lodash';

export interface DatePickerScrollableDialogContentProps extends DialogContentProps {
  DatePickerProps: DatePickerProps;
  /**
   * @deprecated used for testing
   */
  dialogContentClassNameOverride?: string;
}

export function getSelectedMonthDOMElement(dialogContentClassName: string) {
  return document
    .querySelector(`#${dialogContentClassName} .rdp-day_selected`)
    ?.closest('.rdp-month');
}

/**
 * This component is logically tied to DatePicker.tsx, due to reliance on classNames from the day picker elements
 */
const DatePickerScrollableDialogContent = React.forwardRef<
  HTMLDivElement,
  DatePickerScrollableDialogContentProps
>(({ DatePickerProps, dialogContentClassNameOverride, ...rest }, ref) => {
  const dialogContentIdRef = React.useRef<string>(_.uniqueId('date-picker-dialog-content-'));

  const [hasScrolledSelectedDateIntoView, setHasScrolledSelectedDateIntoView] =
    React.useState(false);

  const dialogContentClassName = dialogContentClassNameOverride ?? dialogContentIdRef.current;

  React.useEffect(() => {
    if (hasScrolledSelectedDateIntoView) {
      return;
    }

    const selectedMonth = getSelectedMonthDOMElement(dialogContentClassName);

    const selectedMonthIsInitialMonth = selectedMonth?.classList.contains('rdp-caption_start');

    if (selectedMonth && !selectedMonthIsInitialMonth) {
      selectedMonth.scrollIntoView();
      setHasScrolledSelectedDateIntoView(true);
    }
  }, [hasScrolledSelectedDateIntoView, dialogContentClassName]);

  return (
    <DialogContent {...rest} ref={ref} id={dialogContentClassName}>
      <DatePicker {...DatePickerProps} />
    </DialogContent>
  );
});

export default DatePickerScrollableDialogContent;
